$(document).on("ready turbolinks:load", () => {

        setTimeout(function(){
            if ($(".notice").length > 0){
                $(".notifications").fadeOut(800);
            }
        }, 4000);        
    

    $('#flash-close').on('click',function(){
        $(".notifications").fadeOut(10);
    });
})